// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { BankUploadParseError } from './types';

/**
 * Frontend Excel import is for small manual loads only; bulk goes via
 * support/backend.
 */
export const BANK_UPLOAD_EXCEL_MAX_FILE_BYTES = 1 * 1024 * 1024;

/** Max non-blank data rows on a sheet (main entity or amortizations). */
export const BANK_UPLOAD_EXCEL_MAX_DATA_ROWS = 500;

export const BANK_UPLOAD_EXCEL_MAX_FILE_MB =
  BANK_UPLOAD_EXCEL_MAX_FILE_BYTES / (1024 * 1024);

export const getBankUploadExcelLimitValues = () => ({
  maxMb: BANK_UPLOAD_EXCEL_MAX_FILE_MB,
  maxRows: BANK_UPLOAD_EXCEL_MAX_DATA_ROWS,
});

export const getBankUploadExcelFileSizeError = (
  file: File,
): BankUploadParseError | null => {
  if (file.size <= BANK_UPLOAD_EXCEL_MAX_FILE_BYTES) {
    return null;
  }

  return {
    code: 'file_too_large',
    values: getBankUploadExcelLimitValues(),
  };
};

export const getBankUploadExcelRowCountError = (
  dataRowCount: number,
  sheet?: string,
): BankUploadParseError | null => {
  if (dataRowCount <= BANK_UPLOAD_EXCEL_MAX_DATA_ROWS) {
    return null;
  }

  return {
    code: 'too_many_rows',
    sheet,
    values: {
      ...getBankUploadExcelLimitValues(),
      count: dataRowCount,
    },
  };
};
